//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch } from 'react-redux';
import { Button, Form, Alert, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarehouse,
  faEdit,
  faPlus,
  faMinus,
} from '@fortawesome/free-solid-svg-icons';
import { adjustMaterialQuantity } from 'services/apiRequests/cutting/update';
import { setSpinner } from 'services/store/actions/view';
import Modal from 'PageTemplates/ModalTemplate';

const AdjustMaterialModal = ({
  cuttingPackage,
  materialIndex,
  material,
  availableQuantity,
  closeModal,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const alert = useAlert();

  const [newQuantity, setNewQuantity] = useState(material.quantity);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setNewQuantity(material.quantity);
  }, [material.quantity]);

  const difference = newQuantity - material.quantity;
  const isIncrease = difference > 0;
  const canIncrease = availableQuantity >= difference;

  const handleSubmit = async () => {
    if (newQuantity <= 0) {
      setError('Ilość musi być większa od 0');
      return;
    }

    if (newQuantity === material.quantity) {
      setError('Nowa ilość jest taka sama jak poprzednia');
      return;
    }

    if (isIncrease && !canIncrease) {
      setError(
        `Niewystarczająca ilość w magazynie. Dostępne: ${availableQuantity}`,
      );
      return;
    }

    setLoading(true);
    setError('');

    try {
      dispatch(setSpinner(true));
      await adjustMaterialQuantity(
        cuttingPackage._id,
        materialIndex,
        newQuantity,
        reason,
      );
      dispatch(setSpinner(false));

      alert.success(
        isIncrease
          ? `Zwiększono ilość materiału o ${difference}`
          : `Zmniejszono ilość materiału o ${Math.abs(difference)}`,
      );

      if (onSuccess) onSuccess();
      closeModal();
    } catch (error) {
      dispatch(setSpinner(false));
      setError(
        error.response?.data?.message || 'Błąd podczas korekty materiału',
      );
    } finally {
      setLoading(false);
    }
  };

  const incrementQuantity = () => {
    const newValue = newQuantity + 1;
    if (isIncrease && availableQuantity < newValue - material.quantity) {
      return;
    }
    setNewQuantity(newValue);
  };

  const decrementQuantity = () => {
    const newValue = Math.max(1, newQuantity - 1);
    setNewQuantity(newValue);
  };

  return (
    <Modal
      title={`Korekta ilości materiału`}
      closeModal={closeModal}
      onOk={handleSubmit}
      okButtonText={loading ? 'Zapisywanie...' : 'Zatwierdź korektę'}
      disabled={loading || newQuantity === material.quantity}
      backdrop="static"
      size="md"
    >
      <div className="mb-3">
        <h6 className="text-muted mb-1">Materiał:</h6>
        <h5 className="mb-0">{material.storageItem?.name}</h5>
        <small className="text-muted">
          <FontAwesomeIcon icon={faWarehouse} className="me-1" />
          Typ: {material.storageItem?.type || 'Brak typu'}
        </small>
      </div>

      <div className="mb-3">
        <div className="row">
          <div className="col-6">
            <div className="bg-light p-3 rounded text-center">
              <strong>Aktualna ilość</strong>
              <div className="h4 text-primary mb-0">
                {material.quantity} {material.storageItem?.unit || 'szt.'}
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="bg-light p-3 rounded text-center">
              <strong>Dostępne w magazynie</strong>
              <div className="h4 text-success mb-0">
                {availableQuantity} {material.storageItem?.unit || 'szt.'}
              </div>
            </div>
          </div>
        </div>
      </div>

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <div className="mb-3">
        <Form.Label>Nowa ilość</Form.Label>
        <InputGroup>
          <Button
            variant="outline-secondary"
            onClick={decrementQuantity}
            disabled={newQuantity <= 1}
          >
            <FontAwesomeIcon icon={faMinus} />
          </Button>
          <Form.Control
            type="number"
            value={newQuantity}
            onChange={(e) =>
              setNewQuantity(parseFloat(e.target.value) || 0)
            }
            min="1"
            step="1"
            className="text-center"
          />
          <Button
            variant="outline-secondary"
            onClick={incrementQuantity}
            disabled={isIncrease && !canIncrease}
          >
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </InputGroup>
        {difference !== 0 && (
          <Form.Text
            className={isIncrease ? 'text-primary' : 'text-warning'}
          >
            <FontAwesomeIcon
              icon={isIncrease ? faPlus : faMinus}
              className="me-1"
            />
            {isIncrease ? 'Zwiększenie' : 'Zmniejszenie'} o{' '}
            {Math.abs(difference)} {material.storageItem?.unit || 'szt.'}
            {isIncrease && !canIncrease && (
              <span className="text-danger">
                {' '}
                - niewystarczająca ilość w magazynie!
              </span>
            )}
          </Form.Text>
        )}
      </div>

      <div className="mb-3">
        <Form.Label>Powód korekty (opcjonalnie)</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Np. błąd pomiaru, dodatkowy materiał, szkody..."
        />
      </div>

      <Alert variant="info">
        <small>
          <FontAwesomeIcon icon={faEdit} className="me-1" />
          Korekta zostanie zapisana w historii magazynowej i zaktualizuje
          stan pakietu cięcia.
        </small>
      </Alert>
    </Modal>
  );
};

export default AdjustMaterialModal;
